import React, { useState, useEffect, useRef } from 'react';
import YeonooMonitoring1 from './YeonooMonitoring1';
import YeonooMonitoring2 from './YeonooMonitoring2';
function YeonooMonitoring() {
  const monitoringArray = [<YeonooMonitoring1 rotation={true}/>, <YeonooMonitoring2 rotation={true}/>];
  const [monitoringIndex, setMonitoringIndex] = useState(0);
  useEffect(() => {
    document.title = 'YEONOO MONITORING';

    const intervalId = setInterval(()=>{
      ChangeMonitoring();
    }, 1000 * 30);

    return () => {
      if (intervalId) {
        clearInterval(intervalId);
      }
    };
  },[]);

  function ChangeMonitoring() {
    setMonitoringIndex((previousIndex) => {
      return (previousIndex + 1) % monitoringArray.length
    });
  }

  return (
    <div>
      {monitoringArray[monitoringIndex]}
    </div>
  );
}

export default YeonooMonitoring;